import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import Container from "@material-ui/core/Container";
import {makeStyles} from "@material-ui/core/styles";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import Typography from "@material-ui/core/Typography";
import Alert from "@material-ui/lab/Alert";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import {useHistory} from "react-router-dom";
import useGaTracker from '../../common/components/ga/useGaTracker'
import useGa4Tracker from '../../common/components/ga/useGa4Tracker'

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        height: '100%',
        flexDirection: 'column'
    },
    paper: {
        marginTop: '55px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start'
    },
    paper2: {
        marginTop: '10px',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#fffffff2',
        padding: '0 5% 0 5%',
        borderRadius: '20px',
        minWidth: '315px',
        maxWidth: '680px'
    },
    headerContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        textAlign: "center",
        marginTop: "18px"
    },
    logo: {
        height: "60px"
    },
    info: {
        marginTop: "20px",
        fontSize: "15px"
    },
    button: {
        display: 'flex',
        margin: '20px 0px 20px 0px',
        width: '160px;',
        background: '#940e5f'
    },
    title: {
        fontSize: "35px",
        fontWeight: '700'
    }
}));



export const EndProcess = props => {

 const classes = useStyles();

 const history = useHistory();

 const [t] = useTranslation('common');

 const registerData = useSelector((state) => state.register.data);

 const redirectStepEnd = process.env.REACT_APP_REDIRECTIONS;

 useEffect(() => {
  if (!( registerData  && (registerData.tenantOwnerEmail || registerData.tenantName)) ) {
       history.push('/register-account');
      }
 });

 let currentStep = 'step1';
 
 
if (registerData  && registerData.tenantName ) {
	currentStep = 'step2';
}

useGaTracker('onboarding-' + currentStep + '-success');
useGa4Tracker('onboarding-' + currentStep + '-success');


 return (
  <Container component="main" maxWidth="lg"  className={classes.container}>
   <Paper elevation={3} className={classes.paper2} >
     <div className={classes.paper}>
      <Typography component="h1" variant="h1" margin="normal" className={classes.title}>
       { !(registerData && registerData.tenantName)? t('endProcess.title') : t('endProcessStage2.title') }
         </Typography>
           <Typography component="h1" variant="h3" margin="normal" style={{ marginTop: '30px'}}>
            { !(registerData && registerData.tenantName)? t('endProcess.subtitle') : t('endProcessStage2.subtitle') }
           </Typography>
             <div>
              <Alert severity="success" className={classes.info}>
               { registerData && registerData.tenantOwnerEmail && (<strong> {registerData.tenantOwnerEmail}</strong>)}
               { registerData && registerData.tenantName && (<strong>{t('endProcessStage2.info')} {registerData.tenantName}</strong>)}
                    </Alert>
                </div>
                <Typography component="h1" variant="h3" margin="normal" style={{ marginTop: '30px', fontWeight: 700, marginBottom: '30px'}}>
                    { !(registerData && registerData.tenantName) ?  t('endProcess.subtitle2') : t('endProcessStage2.subtitle2')}
                </Typography>
                { registerData && registerData.tenantName && (<Button href={redirectStepEnd}
                                className={classes.button} color="primary"
                                fullWidth
                                size="large"
                                variant="contained">
                            {t('endProcess.redirectButton')}
                        </Button>)}
            </div>
         </Paper>
        </Container>
   );
}

EndProcess.propTypes = {
    history: PropTypes.object
};
